import { IDictionary } from "@Components/shared/types";
import { isEmpty } from "@Utils";

/**
 * Params for the JSON validator hook
 */
interface IJsonValidatorParams {
    data?: IDictionary;
    schema?: IDictionary;
}

/**
 * Prepare instructions based on the schema and data
 * Tells the user what they need to do
 * @param schema
 * @param data
 * @returns string
 */
function prepareInstructions(hasData: boolean, hasSchema: boolean): string {
    if (!hasSchema && !hasData) return "Please enter in your schema and your data";
    if (!hasSchema) return "Please enter in your schema";
    if (!hasData) return "Please enter in your data";
    return "";
}

const useJsonValidator = ({ data, schema }: IJsonValidatorParams) => {
    const hasSchema = !isEmpty(schema ?? {});
    const hasData = !isEmpty(data ?? {});

    const isComplete = hasData && hasSchema;

    const paragraphText = isComplete ? null : prepareInstructions(hasData, hasSchema);

    return {
        isComplete,
        paragraphText,
        schema,
    };
};

export default useJsonValidator;
